/**
 * All recognised Aria table names.
 *
 * This const array is the single source of truth for both the runtime
 * allowlist (used by SchemaEnforcementPlugin) and the TypeScript union type.
 * To add a new table, add it here — both consumers update automatically.
 */
export const DATA_POINT_EVENT_TYPES = [
    "client_verbose",
    "client_error",
    "client_cosmos",
    "client_event",
    "client_grey_error",
    "client_trace",
    "client_event_dev_only",
    "client_error_external",
    "client_network_request",
    "client_scorecard_event",
    "session",
    "session_secondary_accounts",
    "client_srm_investigation",
    "client_ecs_config_state",
    // Unified Telemetry (UT) tables — used by @outlook/unified_telemetry
    "UnifiedUserAction",
    "UnifiedPerformance",
    "UnifiedClickStream",
    "UnifiedApplicationEvent",
    "PrivacyConcern",
] as const;

export type DataPointEventType = (typeof DATA_POINT_EVENT_TYPES)[number];
